import { IconStatus, Text, Tooltip, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { CustomerSentOrdersResponseNormalized } from '../../../../../../../store/customerDetail/types';
import { getValidatedStatusIcon } from '../../../../../../../utils/getValidatedStatusIcon';

export interface StatusIconProps {
  order: CustomerSentOrdersResponseNormalized;
  withText?: boolean;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ order, withText }) => {
  const statusItem = getValidatedStatusIcon(order.orderStatus.statusIcon);

  const iconContainer = (
    <HStack space={Spacing['inline.quarck']} alignItems="center">
      <IconStatus
        testId="icon-status"
        bgColor={statusItem.backgroundColor}
        icon={statusItem.icon}
        color={statusItem.iconColor}
        size={statusItem.iconSize}
      />
      {withText && !!order.orderStatus.status && (
        <Text textTransform="uppercase">{order.orderStatus.status}</Text>
      )}
    </HStack>
  );

  const errorMessage = order?.error?.internalMessage || order?.error?.externalMessage;

  if (errorMessage) {
    return (
      <Tooltip label={`Motivo: ${errorMessage}`} testId="status-error-message">
        {iconContainer}
      </Tooltip>
    );
  }

  return iconContainer;
};
